"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";

export default function LocaleNotFoundPage() {
  const pathname = usePathname();
  const isArabic = pathname.startsWith("/ar");

  return (
    <main className="standalone-shell">
      <section className="feedback-card">
        <span className="feedback-pill feedback-pill--warning">404</span>
        <h1>{isArabic ? "الصفحة غير موجودة" : "Page not found"}</h1>
        <p>
          {isArabic
            ? "هذه الصفحة غير موجودة."
            : "This page does not exist."}
        </p>
        <Link
          className="feedback-button"
          href={isArabic ? "/ar/admin" : "/en/admin"}
        >
          {isArabic ? "العودة إلى لوحة التحكم" : "Back to dashboard"}
        </Link>
      </section>
    </main>
  );
}
